import { gql } from '@apollo/client';

const GET_ACTIVITY = gql`
  query ($where: ReadActivityWhereInput!) {
    findTheLetter(where: $where) {
      description
      book {
        id
        bookCode
        type
        title
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      pages {
        png {
          src
          spreadLayout
        }
        page {
          id
          pageNumber
        }
        contents {
          description
          occurrences
        }
      }
      sound {
        src
        description
      }
    }
  }
`;
export default GET_ACTIVITY;
